import React from 'react'
import './Card.css'

const Card = () => {
  return (
    <div>
         <section id="cards">
            <h1 class="heading">Our Top Cards</h1>
             <p class="heading-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid quod odio possimus minima voluptatum excepturi voluptatem iure natus, neque reprehenderit.</p>
            <div class="section">
                <div class="container cards">
                    <h3>BankIT Platinum</h3>
                    <p class="credit-card">Credit Card</p>
                    <div class="line"></div>
                    <h3>Overview</h3>
                    <p>Monthly Service Fee from:</p>
                    <h3>R99 p/m</h3>
                    <p>Minimum income:</p>
                    <h3>R29 000</h3>
                    <p>Interest rate:</p>
                    <h3>Personalised</h3>
                    <a href="" class="apply">Apply Now</a>
                </div>

            <div>
                <div class="container cards">
                    <h3>BankIT Platinum</h3>
                    <p class="credit-card">Credit Card</p>
                    <div class="line"></div>
                    <h3>Overview</h3>
                    <p>Monthly Service Fee from:</p>
                    <h3>R99 p/m</h3>
                    <p>Minimum income:</p>
                    <h3>R29 000</h3>
                    <p>Interest rate:</p>
                    <h3>Personalised</h3>
                    <a href="" class="apply">Apply Now</a>
                </div>
            </div>

            </div>
        </section>
    </div>
  )
}

export default Card
